export default __webpack_public_path__ + "static/media/background.0a9e482a.png";